import { deleteUserSuccess, togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"

// Login Redux States
import {
  add_users_for_projects,
  category_user,
  get_agents,
  get_billing_types,
  get_category,
  get_project_status,
  get_project_status_total_hours,
  new_sub_category,
  new_user,
  post_CreateCategoryUserLink,
  save_category,
  users_based_on_projects,
} from "helpers/backend_helper"
import {
  NewSubCategoryError,
  NewSubCategorysuccess,
  categoryUserError,
  categoryUsersuccess,
  deleteUserError,
  getAgentSuccess,
  getAllBillingTypesSuccess,
  getCategorySuccess,
  getProjectStatusError,
  getProjectStatusSuccess,
  getProjectStatusTotalHoursError,
  getProjectStatusTotalHoursSuccess,
  getUserError,
  getUserSuccess,
  getuploadcategoryError,
  getuploadcategorysuccess,
  postUserCategorylinkError,
  postUserCategorylinkSuccess,
} from "./action"
import {
  CATEGORY_USER,
  CREATE_USERS_FOR_PROJECTS,
  DELETE_CATEGORY_USER,
  GET_CATEGORY,
  GET_ALL_AGENT_DATAILS,
  GET_ALL_BILLING_TYPES,
  GET_USER_BY_PROJECT,
  SAVE_UPLOAD_GATEGORY,
  SUB_CATEGORY,
  CATEGORY_USER_CATEGORY_LINK,
  GET_PROJECT_STATUS,
  GET_PROJECT_STATUS_TOTAL_HOURS,
} from "./actiontype"

function* getAllAgentDetails() {
  try {
    // yield put(togglePageLoader(true))
    const response = yield call(get_agents)
    if (response.statusCode === 200) {
      yield put(getAgentSuccess(response))
      // yield put(togglePageLoader(false))
    } else {
      //   yield put(getAccessgroupError(response));
      //   yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response.message : error)
    // yield put(getAccessgroupError(error));
    // yield put(togglePageLoader(false))
  }
}

function* getAllBillingTypes() {
  try {
    // yield put(togglePageLoader(true))
    const response = yield call(get_billing_types)
    if (response.statusCode === 200) {
      yield put(getAllBillingTypesSuccess(response))
      // yield put(togglePageLoader(false))
    } else {
      //   yield put(getAccessgroupError(response));
      //   yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response.message : error)
    // yield put(getAccessgroupError(error));
    // yield put(togglePageLoader(false))
  }
}

function* getAllCategory({ payload: params }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_category, params)
    if (response.statusCode === 200) {
      yield put(getCategorySuccess(response))
      yield put(togglePageLoader(false))
    } else {
      //   yield put(getAccessgroupError(response));
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response.message : error)
    // yield put(getAccessgroupError(error));
    yield put(togglePageLoader(false))
  }
}
function* uploadCategory({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(save_category, params)
    if (response.statusCode === 200) {
      yield put(getuploadcategorysuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(getuploadcategoryError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    toast.error(error?.response ? error.response.message : error)
    yield put(getuploadcategoryError(error))
    yield put(togglePageLoader(false))
  }
}
function* categoryUser({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(new_user, params)
    if (response.statusCode === 200) {
      yield put(categoryUsersuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(categoryUserError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(categoryUserError(error))
    toast.error(error?.response ? error.response.message : error)
    yield put(togglePageLoader(false))
  }
}
function* subcategory({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(new_sub_category, params)
    if (response.statusCode === 200) {
      yield put(NewSubCategorysuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(NewSubCategoryError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(NewSubCategoryError(error))
    toast.error(error?.response ? error.response.message : error)
    yield put(togglePageLoader(false))
  }
}
function* deletecategoryUser({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(category_user, params)
    if (response.statusCode === 200) {
      yield put(deleteUserSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(deleteUserError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(deleteUserError(error))
    toast.error(error?.response ? error.response.message : error)
    yield put(togglePageLoader(false))
  }
}

function* getUsers({ payload: params }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(users_based_on_projects, params)
    if (response.statusCode === 200) {
      yield put(getUserSuccess(response, params))
      yield put(togglePageLoader(false))
    } else {
      yield put(getUserError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getUserError(error))
    yield put(togglePageLoader(false))
  }
}

function* addUsersforProjects({ payload: params, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(add_users_for_projects, params)
    if (response.statusCode === 200) {
      // toast.success(response.message)
      yield put(togglePageLoader(false))
      callback && callback("SUCCESS")
    } else {
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback && callback("FAILURE")
    }
  } catch (error) {
    toast.error(error?.response ? error.response.message : error)
    yield put(togglePageLoader(false))
  }
}
// category link by user
function* postCreateCategoryUserLink({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_CreateCategoryUserLink, data)
    if (response?.statusCode === 200) {
      yield put(postUserCategorylinkSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(postUserCategorylinkError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(postUserCategorylinkError(error))
    yield put(togglePageLoader(false))
  }
}
function* getProjectStatus() {
  try {
    const response = yield call(get_project_status)
    if (response.statusCode === 200) {
      yield put(getProjectStatusSuccess(response))
    } else {
      yield put(getProjectStatusError(response))
    }
  } catch (error) {
    yield put(getProjectStatusError(error))
  }
}
function* getProjectStatusTotalHours({ payload: projectID }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_project_status_total_hours, projectID)
    if (response.statusCode === 200) {
      yield put(getProjectStatusTotalHoursSuccess(response?.projectTotalHours))
      yield put(togglePageLoader(false))
    } else {
      yield put(getProjectStatusTotalHoursError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getProjectStatusTotalHoursError(error))
    yield put(togglePageLoader(false))
  }
}
function* manageclientage() {
  yield takeEvery(GET_CATEGORY, getAllCategory)
  yield takeEvery(SAVE_UPLOAD_GATEGORY, uploadCategory)
  yield takeEvery(CATEGORY_USER, categoryUser)
  yield takeEvery(SUB_CATEGORY, subcategory)
  yield takeEvery(DELETE_CATEGORY_USER, deletecategoryUser)
  yield takeEvery(GET_USER_BY_PROJECT, getUsers)
  yield takeEvery(CREATE_USERS_FOR_PROJECTS, addUsersforProjects)
  yield takeEvery(GET_ALL_AGENT_DATAILS, getAllAgentDetails)
  yield takeEvery(GET_ALL_BILLING_TYPES, getAllBillingTypes)
  yield takeEvery(CATEGORY_USER_CATEGORY_LINK, postCreateCategoryUserLink)
  yield takeEvery(GET_PROJECT_STATUS, getProjectStatus)
  yield takeEvery(GET_PROJECT_STATUS_TOTAL_HOURS, getProjectStatusTotalHours)
}

export default manageclientage
